import React from 'react';
import FormLayout from '../components/FormLayout';
import FormHeader from '../components/FormHeader';
import CustomLink from '../components/CustomLink';
import Login from '../components/Login';

const LoginPage: React.FC = () => {
  return (
    <FormLayout>
      <FormHeader title="Welcome Back" subtitle="Sign in to your PRAIRI account" />

      <Login />

      {/* Additional Links */}
      <div className="mt-6 text-center">
        <p className="text-gray-400 text-sm">
          Not a member? <CustomLink to="/startups/pricing">Sign up here</CustomLink>
        </p>
      </div>
    </FormLayout>
  );
};

export default LoginPage;
